import React from "react";
import './T&C.css';

const navItems = [
    { id: "general-terms", label: "General Terms" },
    { id: "scope-of-work", label: "Scope of Work" },
    { id: "pricing-payments", label: "Pricing & Payments" },
    { id: "delivery-installation", label: "Delivery & Installation" },
    { id: "no-refund-policy", label: "No Refund Policy" },
    { id: "replacement-policy", label: "Replacement Policy" },
    { id: "warranty", label: "Warranty" },
    { id: "limitation-of-liability", label: "Limitation of Liability" },
    { id: "force-majeure", label: "Force Majeure" },
    { id: "governing-law", label: "Governing Law" },
    { id: "escalation-matrix", label: "3-Level Escalation Matrix" },
    { id: "escalation-compliance", label: "Escalation Compliance" },
    { id: "acceptance", label: "Acceptance" },
];

const TCcontent = () => {
    return (
        <div className="TC-page">
            <section className="TCcontent">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title-LowerCase">Terms & Conditions</h1>
                </div>

                <div className="TCtext">

                    {/* Intro card */}
                    <div className="tc-card tc-intro-card">
                        <h2 className="tc-intro-title">Terms & Conditions, Refund & Replacement Policy</h2>
                        <p className="tc-intro-sub">Callistus Blinds Middle East F.Z.E. | www.callistusblinds.ae</p>
                    </div>

                    {/* Quick Navigation card */}
                    <div className="tc-card tc-nav-card">
                        <h3 className="tc-nav-title">QUICK NAVIGATION</h3>
                        <ul className="tc-nav-list">
                            {navItems.map((item) => (
                                <li key={item.id}>
                                    <a href={`#${item.id}`}>{item.label}</a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* 1. General Terms */}
                    <div className="tc-card" id="general-terms">
                        <div className="tc-card-header">
                            <span className="tc-num">1</span>
                            <h3 className="tc-card-title">General Terms</h3>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">1.1</span>
                            <p>These Terms & Conditions (“T&C”) govern all sales, services, and transactions conducted through Callistus Blinds Middle East F.Z.E. (“Company”, “we”, “our”).</p>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">1.2</span>
                            <p>By placing an order, the customer (“Client”) agrees to be bound by these T&C without exception.</p>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">1.3</span>
                            <p>All products offered are <strong>custom-made, made-to-measure, and/or project-specific</strong>, unless explicitly stated otherwise.</p>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">1.4</span>
                            <p>The Company reserves the right to modify these terms at any time without prior notice.</p>
                        </div>
                    </div>

                    {/* 2. Scope of Work */}
                    <div className="tc-card" id="scope-of-work">
                        <div className="tc-card-header">
                            <span className="tc-num">2</span>
                            <h3 className="tc-card-title">Scope of Work</h3>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">2.1</span>
                            <div>
                                <p>The Company specializes in:</p>
                                <ul className="tc-bullets">
                                    <li>Window blinds (manual and motorized)</li>
                                    <li>Curtains and shading systems</li>
                                    <li>Automation-integrated solutions</li>
                                </ul>
                            </div>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">2.2</span>
                            <p>All specifications including dimensions, fabric, motorization, and finishes are <strong>final upon order confirmation</strong>.</p>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">2.3</span>
                            <div>
                                <p>Any changes after confirmation shall:</p>
                                <ul className="tc-bullets">
                                    <li>Be subject to feasibility</li>
                                    <li>Attract additional charges</li>
                                    <li>Impact delivery timelines</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* 3. Pricing & Payments */}
                    <div className="tc-card" id="pricing-payments">
                        <div className="tc-card-header">
                            <span className="tc-num">3</span>
                            <h3 className="tc-card-title">Pricing & Payments</h3>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">3.1</span>
                            <p>All prices are quoted in AED unless stated otherwise.</p>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">3.2</span>
                            <div>
                                <p>Orders are processed only upon:</p>
                                <ul className="tc-bullets">
                                    <li>Advance payment</li>
                                    <li>Written or digital confirmation</li>
                                </ul>
                            </div>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">3.3</span>
                            <div>
                                <p>Delayed payments may result in:</p>
                                <ul className="tc-bullets">
                                    <li>Suspension of production</li>
                                    <li>Revised delivery timelines</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* 4. Delivery & Installation */}
                    <div className="tc-card" id="delivery-installation">
                        <div className="tc-card-header">
                            <span className="tc-num">4</span>
                            <h3 className="tc-card-title">Delivery & Installation</h3>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">4.1</span>
                            <div>
                                <p>Delivery timelines are indicative and may vary due to:</p>
                                <ul className="tc-bullets">
                                    <li>Material availability</li>
                                    <li>Production availability</li>
                                    <li>Site readiness</li>
                                </ul>
                            </div>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">4.2</span>
                            <div>
                                <p>The Client must ensure:</p>
                                <ul className="tc-bullets">
                                    <li>Site access readiness</li>
                                    <li>Electrical provisions for motorized systems</li>
                                    <li>Accurate measurement approval</li>
                                </ul>
                            </div>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">4.3</span>
                            <p>Any delay caused by the Client shall not be attributable to the Company.</p>
                        </div>
                    </div>

                    {/* 5. No Refund Policy */}
                    <div className="tc-card" id="no-refund-policy">
                        <div className="tc-card-header">
                            <span className="tc-num">5</span>
                            <h3 className="tc-card-title">No Refund Policy</h3>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">5.1</span>
                            <div>
                                <p><strong>Strictly No Refunds</strong> shall be applicable under any circumstances, including but not limited to:</p>
                                <ul className="tc-bullets">
                                    <li>Change of mind</li>
                                    <li>Project cancellation</li>
                                    <li>Delay caused by external dependencies</li>
                                    <li>Incorrect measurements approved by the Client</li>
                                </ul>
                            </div>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">5.2</span>
                            <p>Payments once made are <strong>non-reversible and non-transferable</strong>.</p>
                        </div>
                    </div>

                    {/* 6. Replacement Policy */}
                    <div className="tc-card" id="replacement-policy">
                        <div className="tc-card-header">
                            <span className="tc-num">6</span>
                            <h3 className="tc-card-title">Replacement Policy (Only)</h3>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">6.1</span>
                            <p>The Company follows a <strong>Replacement-Only Policy</strong>.</p>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">6.2</span>
                            <div>
                                <p>Replacement shall be considered only if:</p>
                                <ul className="tc-bullets">
                                    <li>Product is defective upon delivery</li>
                                    <li>Manufacturing defect is identified</li>
                                    <li>Wrong product is delivered and does not match the confirmed order</li>
                                </ul>
                            </div>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">6.3</span>
                            <div>
                                <p>Replacement requests must be:</p>
                                <ul className="tc-bullets">
                                    <li>Raised within <strong>24 hours of delivery or installation</strong></li>
                                    <li>Supported with photographic or video evidence</li>
                                </ul>
                            </div>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">6.4</span>
                            <div>
                                <p>Replacement will <strong>not</strong> be applicable in cases of:</p>
                                <ul className="tc-bullets">
                                    <li>Damage due to misuse or mishandling</li>
                                    <li>Wear and tear</li>
                                    <li>Environmental factors such as humidity, dust, or similar conditions</li>
                                    <li>Unauthorized modifications</li>
                                </ul>
                            </div>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">6.5</span>
                            <div>
                                <p>Approved replacements will be:</p>
                                <ul className="tc-bullets">
                                    <li>Processed within standard production timelines</li>
                                    <li>Provided for the defective component only, not the entire order unless justified</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* 7. Warranty */}
                    <div className="tc-card" id="warranty">
                        <div className="tc-card-header">
                            <span className="tc-num">7</span>
                            <h3 className="tc-card-title">Warranty</h3>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">7.1</span>
                            <div>
                                <p>Warranty, if applicable, is limited to:</p>
                                <ul className="tc-bullets">
                                    <li>Manufacturing defects</li>
                                    <li>Motor and automation components as stated in warranty certificates or quotations submitted by the Company</li>
                                </ul>
                            </div>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">7.2</span>
                            <div>
                                <p>Warranty does not cover:</p>
                                <ul className="tc-bullets">
                                    <li>Improper usage</li>
                                    <li>Electrical faults at site</li>
                                    <li>Third-party tampering</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* 8. Limitation of Liability */}
                    <div className="tc-card" id="limitation-of-liability">
                        <div className="tc-card-header">
                            <span className="tc-num">8</span>
                            <h3 className="tc-card-title">Limitation of Liability</h3>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">8.1</span>
                            <div>
                                <p>The Company’s liability is strictly limited to:</p>
                                <ul className="tc-bullets">
                                    <li>Repair or replacement of defective product</li>
                                </ul>
                            </div>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">8.2</span>
                            <div>
                                <p>Under no circumstances shall the Company be liable for:</p>
                                <ul className="tc-bullets">
                                    <li>Indirect or consequential losses</li>
                                    <li>Business interruption</li>
                                    <li>Loss of profits or reputation</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* 9. Force Majeure */}
                    <div className="tc-card" id="force-majeure">
                        <div className="tc-card-header">
                            <span className="tc-num">9</span>
                            <h3 className="tc-card-title">Force Majeure</h3>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">9.1</span>
                            <div>
                                <p>The Company shall not be held responsible for delays or failures caused by:</p>
                                <ul className="tc-bullets">
                                    <li>Natural disasters</li>
                                    <li>Government restrictions</li>
                                    <li>Supply chain disruptions</li>
                                    <li>Labor issues</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* 10. Governing Law */}
                    <div className="tc-card" id="governing-law">
                        <div className="tc-card-header">
                            <span className="tc-num">10</span>
                            <h3 className="tc-card-title">Governing Law</h3>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">10.1</span>
                            <p>These terms shall be governed by the laws of the <strong>United Arab Emirates</strong>.</p>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">10.2</span>
                            <p>Any disputes shall fall under the jurisdiction of Dubai only.</p>
                        </div>
                    </div>

                    {/* 11. 3-Level Escalation Matrix */}
                    <div className="tc-card" id="escalation-matrix">
                        <div className="tc-card-header">
                            <span className="tc-num">11</span>
                            <h3 className="tc-card-title">3-Level Escalation Matrix</h3>
                        </div>
                        <p className="tc-card-intro">To ensure structured resolution, the Company follows a <strong>Three-Tier Escalation Framework</strong>.</p>

                        <div className="tc-clause">
                            <span className="tc-clause-num">11.1</span>
                            <div>
                                <p className="tc-sub-title">Level 1: Authorized Dealer / Channel Partner</p>
                                <ul className="tc-bullets">
                                    <li>Primary point of contact for all issues</li>
                                    <li>Applicable for product concerns, installation issues, initial defect reporting, and service coordination</li>
                                    <li>The Client must contact the authorized dealer from whom the blinds, curtains, or accessories were purchased</li>
                                    <li>The dealer is responsible for first-level diagnosis, basic resolution, and coordination with Company backend teams if required</li>
                                    <li>Resolution timeline: As per dealer SLA</li>
                                </ul>
                            </div>
                        </div>

                        <div className="tc-clause">
                            <span className="tc-clause-num">11.2</span>
                            <div>
                                <p className="tc-sub-title">Level 2: Company Support Desk</p>
                                <ul className="tc-bullets">
                                    <li>Triggered when the issue remains unresolved at dealer level or technical intervention from the Company is required</li>
                                    <li>The dealer or Client may escalate with order details, issue description, and supporting evidence such as photos or videos</li>
                                    <li>Response time: Within 24 business hours</li>
                                    <li>Resolution timeline: 3 to 5 business days depending on case complexity</li>
                                    <li>Contact: support@callistusblinds.ae</li>
                                </ul>
                            </div>
                        </div>

                        <div className="tc-clause">
                            <span className="tc-clause-num">11.3</span>
                            <div>
                                <p className="tc-sub-title">Level 3: Management Escalation</p>
                                <ul className="tc-bullets">
                                    <li>Triggered only if the issue remains unresolved for 7 business days after Level 2 escalation</li>
                                    <li>Applicable for critical project delays, repeated service failures, and contractual or commercial disputes</li>
                                    <li>Cases are reviewed by Senior Management for final resolution</li>
                                    <li>Response time: Within 48 hours</li>
                                    <li>Resolution timeline: Priority-based and case dependent</li>
                                    <li>Contact: management@callistusblinds.ae</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* 12. Escalation Compliance */}
                    <div className="tc-card" id="escalation-compliance">
                        <div className="tc-card-header">
                            <span className="tc-num">12</span>
                            <h3 className="tc-card-title">Escalation Compliance</h3>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">12.1</span>
                            <p>Direct escalation to Level 2 or Level 3 without following prior levels may not be entertained.</p>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">12.2</span>
                            <p>All escalations must include complete documentation and communication history.</p>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">12.3</span>
                            <p>The Company reserves the right to reject incomplete or non-compliant escalation requests.</p>
                        </div>
                    </div>

                    {/* 13. Acceptance */}
                    <div className="tc-card" id="acceptance">
                        <div className="tc-card-header">
                            <span className="tc-num">13</span>
                            <h3 className="tc-card-title">Acceptance</h3>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">13.1</span>
                            <p>The Client confirms full understanding of these terms.</p>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">13.2</span>
                            <p>The Client accepts the <strong>No Refund / Replacement-Only</strong> policy.</p>
                        </div>
                        <div className="tc-clause">
                            <span className="tc-clause-num">13.3</span>
                            <p>The Client agrees to the escalation structure.</p>
                        </div>
                    </div>

                </div>
            </section>
        </div>
    );
}

export default TCcontent;